import React from 'react'
import classNames from 'classnames'
// import sanitizeHtml from 'sanitize-html'
import DOMPurify from 'isomorphic-dompurify'
import style from './content.module.scss'
interface Content {
  content: string
  className: string
}

const HtmlContent = ({ content = '', className = '' }): React.ReactElement<Content> => {
  const clean = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      'a',
      'b',
      'blockquote',
      'br',
      'del',
      'div',
      'em',
      'figcaption',
      'figure',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'hr',
      'i',
      'img',
      'li',
      'mark',
      'ol',
      'p',
      'section',
      'span',
      'strong',
      'sub',
      'sup',
      'table',
      'tr',
      'td',
      'u',
      'ul'
    ],
    ALLOWED_ATTR: ['style', 'href', 'rel', 'src', 'align', 'alt', 'width', 'height', 'class']
  })

  const classes = classNames({
    [style.text]: true,
    [className]: Boolean(className)
  })
  return (
    <div className={classes} dangerouslySetInnerHTML={{ __html: clean }} />
  )
}

export default HtmlContent
